export default "__VITE_ASSET__CWiCJSTN__"